

import Vue from 'vue'
import App from './App'
import router from './router'
import login from './views/login/login'
import foot from './components/foot'
import vHeader from './components/vHeader'
import myHead from './components/header/myHead'
import print from './views/print/print'
import materialCompare from './views/materialCompare/materialCompare'
import request, { baseURL } from './request/request'
import store from './vuex'
import common from '@/common/common.js'

import printNotice from './views/printNotice/printNotice'


import footInfo from './components/footInfo'

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
ak: '8yYf3ywN6SLUToxURI2XIP3UTavSTYXL'
})


import AlertPlugin from 'vux/src/plugins/alert/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import trim from 'vux/src/tools/string/trim'

import wx from 'weixin-js-sdk'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin, Actionsheet, XHeader, )
Vue.component('login', login)
Vue.component('foot', foot)
Vue.component('vHeader', vHeader)
Vue.component('myHead', myHead)
Vue.component('print', print)
Vue.component('materialCompare', materialCompare)
Vue.component('printNotice', printNotice)
Vue.component('footInfo', footInfo)
Vue.prototype.$common = common
Vue.prototype.$request = request
Vue.prototype.$baseURL = baseURL
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.prototype.$trim = trim

Vue.config.productionTip = false

Vue.prototype.$shareList = function (imgUrl, link, desc, title) {



this.$request.post('/pay/getShareParam', { url: encodeURIComponent(window.location.href.split('#')[0]) }).then(function (data) {

wx.config({
debug: false, // true:是调试模式,调试时候弹窗,会打印出日志
appId: 'wx02774a0bb8cb2b6c', // 微信appid
timestamp: data.obj.timestamp, // 时间戳
nonceStr: data.obj.noncestr, // 随机字符串
signature: data.obj.signature, // 签名
jsApiList: [

'onMenuShareTimeline', // 分享到朋友圈接口
'onMenuShareAppMessage', //  分享到朋友接口
'onMenuShareQQ', // 分享到QQ接口
'onMenuShareWeibo', // 分享到微博接口
'updateTimelineShareData',
'updateAppMessageShareData',
'onMenuShareQZone'
]
})
wx.checkJsApi({
jsApiList: [

'onMenuShareTimeline', // 分享到朋友圈接口
'onMenuShareAppMessage', //  分享到朋友接口
'onMenuShareQQ', // 分享到QQ接口
'onMenuShareWeibo', // 分享到微博接口
'updateTimelineShareData',
'updateAppMessageShareData',
'onMenuShareQZone'
],
success: function (res) {

}
})
wx.ready(function () {

var shareData = {
imgUrl: imgUrl, // 分享显示的缩略图地址
link: link, // 分享地址
desc: desc, // 分享描述
title: title, // 分享标题
success: function () {






},
fail: function () {


},
complete: function () {


}
}
wx.onMenuShareQZone(shareData)
wx.updateTimelineShareData(shareData)
wx.updateAppMessageShareData(shareData)
wx.onMenuShareQQ(shareData)
wx.onMenuShareWeibo(shareData)
})
wx.error(function (res) {



console.log(res)


})
}, function (res) {


})
}


Vue.prototype.$utils=function(name){
return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
}

function getCookie(name) {
var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
if (arr = document.cookie.match(reg))
return unescape(arr[2]);
else
return null;
}

function setCookie(cname, cvalue, exdays) {



var d = new Date();
d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + "; " + expires+"; path=/"   
}

Vue.prototype.$token = getCookie('_token')

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>',
mounted () {

}
})





var equipment=''

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
equipment = '手机'



} else {
equipment = '电脑'




}

console.log('equipment',equipment);



router.beforeEach((to, from, next) => {











if (to.matched.some(record => record.meta.requireLogin)){  // 判断该路由是否需要登录权限
if(to.query.token){
setCookie('_token', to.query.token, 0.288)
}
if (getCookie('_token') || to.query.token) {  // 判断当前用户的登录token是否存在
next();
} else {
next({
path: '/login',
query: {
fullPath: to.fullPath
}
})
}
}else {
next();
}
})



// WEBPACK FOOTER //
// ./src/main.js